<template>
  <b-container class="widget-list px-0">
    <b-col md="12">
      <router-link
        :to="{ name: 'Broadcasts' }"
        tag="div"
        class="back-to-list">
        <icon name="angle-left"/> Back to Broadcasts
      </router-link>
    </b-col>
    <b-col
      offset-md="3"
      md="6">
      <div class="form-card">
        <div class="text-center">
          <h1>Pop-up Widget</h1>
          <p class="permission-notification">
            Create and manage your Messenger pop-up widgets here.
          </p>
          <a class="create-new">
            <icon
              name="plus"
              width="14"
              height="14"/> Create New</a>
        </div>
        <b-col
          md="12"
          class="modal-items">
          <b-row class="mx-0">
            <b-col
              md="12"
              class="modal-item">
              <div class="modal-details float-left">
                <span>
                  <img
                    class="img-responsive"
                    src="~@/assets/img/popup-widget-black-light.svg"
                    alt="Popup Widget">
                </span>
                <span
                  class="modal-name">
                  Modal 1
                </span>
              </div>
              <div class="connect-button float-right">
                <a class="btn-view">
                  View
                </a>
              </div>
            </b-col>
          </b-row>
          <b-row class="mx-0">
            <b-col
              md="12"
              class="modal-item">
              <div class="modal-details float-left">
                <span>
                  <img
                    class="img-responsive"
                    src="~@/assets/img/popup-widget-black-light.svg"
                    alt="Popup Widget">
                </span>
                <span
                  class="modal-name">
                  Modal 2
                </span>
              </div>
              <div class="connect-button float-right">
                <a class="btn-view">
                  View
                </a>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </div>
    </b-col>
  </b-container>
</template>

<script>
export default {
  name: 'WidgetList',
  data() {
    return {
      modals: [],
    };
  },
  created() {
    //
  },
  methods: {
    //
  },
};
</script>
